import classNames from 'classnames';

import AvatarButton from '../buttons/AvatarButton';
import EditContact from '../forms/EditContactForm';
import ProfileForm from '../forms/ProfileForm';
import SectionTitle from '../typography/SectionTitle';

import styles from '../../styles/panels/account-panel.module.css';

interface AccountProfilePanelProps {
    className?: string;
}

function AccountProfilePanel({ className }: AccountProfilePanelProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.section}>
                <SectionTitle className={styles.title}>Modifier votre profil</SectionTitle>
                {/* <div className={styles.box}> */}
                <AvatarButton className={styles.avatar} />
                <div className={classNames([styles.row, styles.fieldRow])}>
                    <EditContact
                        type="email"
                        className={styles.form}
                        inputClassName={styles.input}
                    />
                    <EditContact
                        type="phone"
                        className={styles.form}
                        inputClassName={styles.input}
                    />
                </div>
                <ProfileForm withDelete className={styles.form} inputClassName={styles.input} />
                {/* </div> */}
            </div>
        </div>
    );
}

export default AccountProfilePanel;
